import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnnouncementsService, Announcement, OrgTypeList } from '../../lib/announcements.service';
import { ModalService } from '../../lib/modal.service';
import { LogService } from '../../lib/log.service';

@Component({
  selector: 'app-announcement-display',
  templateUrl: './announcement-display.component.html',
  styleUrls: ['./announcement-display.component.scss']
})
export class AnnouncementDisplayComponent implements OnInit {
  @Input() announcement: Announcement;
  @Input() user: any;
  @Output() contentClick = new EventEmitter<MouseEvent>();

  userConsent: boolean = false;
  userDecline: boolean = false;

  constructor(
    private translate: TranslateService,
    private announcementService: AnnouncementsService,
    private modalService: ModalService,
    private log: LogService
  ) {}

  ngOnInit(): void {}

  onAnnouncementContentClick(event: MouseEvent): void {
    this.contentClick.emit(event);
  }

  onConsentChange(): void {
    if (this.userDecline) {
      this.userDecline = false;
    }
  }

  onDeclineChange(): void {
    if (this.userConsent) {
      this.userConsent = false;
    }
  }

  onSaveConsent(): void {
    if (this.userConsent || this.userDecline) {
      this.announcementService.updateUserConsent({
        UserID: this.user.id,
        AnnouncementID: this.announcement.ID,
        Consent: this.userConsent
      }).subscribe((result: any) => {
        this.announcement.user_consent = result;
        this.modalService.showAlert('Success', 'User consent saved successfully');
      },
      (error) => {
        this.log.error(`Error saving user consent: ${error}`);
        this.modalService.showAlert('Error', 'Failed to save user consent');
      });
      
      // Reset the checkboxes
      this.userConsent = false;
      this.userDecline = false;
    }
  }

  getTranslatedCustomerType(): string {
    if (this.announcement) {
      const customerType = OrgTypeList.find(o => o.id === this.announcement?.ServiceType)?.type || '';
      if (customerType) {
        return this.translate.instant(`organizationTypes.${customerType}`);
      }
    }
    return '';
  }

  shouldShowConsent(): boolean {
    return this.announcement?.IsChallenge && !this.announcement?.user_consent;
  }
}
